import Sidebar from "../../components/profile/Sidebar";
import Topbar from "../../components/profile/Topbar";
import Main from "../../components/profile/Main";
const Profile = () => {
    return (
        <div className="py-10 lg:px-8 px-0">
            {/* <h1>working</h1> */}
            <Topbar className="px-8 lg:px-0"/>
            <div className="border border-orange-500 drop-shadow-2xl rounded-2xl mt-8 flex flex-col lg:flex-row">
                <Sidebar />
                <Main />
            </div>
            
        </div>
    )
}

export default Profile;